import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Post } from 'Xhr/Xhr';
import { GetReceptions } from './GetReceptions';
import { env } from 'env';

export const DeleteReceiption = async (
  id,
  setReceptions,
  idTestimontial
) => {
  console.log('idTestimontial=>', {
    setReceptions,
    idTestimontial,
  });
  Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_DELETE_FISH_HAYE_PARDAKHT_LIST}`,
    true,
    {
      id,
    }
  ).then((response) => {
    if (response.data.resCode === 1) {
      GetReceptions(idTestimontial, setReceptions);
    } else
      SwalAlert('error', response.data.resMessage, false);
  });
};
